module.exports = __webpack_public_path__ + "static/img/charts.dd38072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/charts.png
// module id = w3Cp
// module chunks = 1